import actionTypes from '../constants/action-types';

const setPageTemplateHTML = (pageTemplateId, html) => ({
  type: actionTypes.SET_PAGE_TEMPLATE_HTML,
  payload: {
    pageTemplateId,
    html,
  },
});

export default setPageTemplateHTML;
